const elements = document.getElementsByClassName('read-more__wrapper');

for (let i = 0; i < elements.length; i++) {
  const element = elements[i];
  const wrapperHeight = element.offsetHeight;
  const contentHeight = element.querySelector(
    '.read-more__content'
  ).offsetHeight;
  const elementButton = element.getElementsByClassName('read-more__toggle')[0];

  if (wrapperHeight > contentHeight) {
    element.classList.add('read-more__expanded');
  } else {
    elementButton.classList.remove('read-more__toggle-hidden');
  }

  elementButton.addEventListener('click', (_) => {
    const contentHeight = element.querySelector(
      '.read-more__content'
    ).offsetHeight;
    element.style.setProperty(
      '--read-more-content-height',
      contentHeight + 50 + 'px'
    );
    element.classList.add('read-more__expanded');
  });
}
